export default __webpack_public_path__ + "be200c0847ad86cda152b8a19e0ede06.png";